import getReduxSelector from 'modules/redux/selectors/get'
import getSummaryPathByMemberIdSquadUtil from 'modules/squad/redux/utils/get-summary-path-by-member-id'

const getSummaryByMemberIdSquadSelector = id => state => {
  const path = getSummaryPathByMemberIdSquadUtil(id)
  return getReduxSelector(path)(state)
}

export default getSummaryByMemberIdSquadSelector
